import type { PricePulseState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/pricePulse/pricePulse';

export type {
  PricePulseMap,
  PricePulseState,
} from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/pricePulse/pricePulse';
export { INITIAL_STATE, pricePulseReducer } from './pricePulseReducer';

export const get = (state: PricePulseState, itineraryId: string) => state.byId[itineraryId];
